<main>
  <div class="s1-status-header fender" [style.background-image]="'url(' + randomBackgroundImage + ')'">
    <div class="s1-status-header-content">
      <div class="guest-home-hero-content">
        <fui-heading text="Welcome to MyFender" [level]="1" fontSize="f11" color="#fff"></fui-heading>
        <p class="guest-home-tagline">Your home for gear, learning, community, and events. Sign in to register your gear and track your progress, or explore below.</p>
        <div class="guest-home-hero-cta">
          <button class="btn btn-primary" (click)="signIn()">Sign in or create account</button>
          <a class="btn btn-transparent-light" [routerLink]="['/learn']">Explore Learn</a>
        </div>
      </div>
    </div>
  </div>

  <div basepage="primary" class="fullwidth-layout-container">
    <div class="row">
      <div class="col-12">
        @if (newEvents.length || newEventsLoading) {
          <section class="home-section m-b-50 w-full m-t-50" aria-label="upcoming events">
            <div class="section-header is-grid">
              <fui-heading [text]="'sphere.special_events' | translate" extraClasses="m-b-20" [level]="2" fontSize="f8"></fui-heading>
              <a class="section-header-link" [routerLink]="['/events']">{{ "sphere.view_all" | translate }}</a>
            </div>
            @if (newEventsLoading) {
              <myp-inline-loader [loading]="newEventsLoading" height="100px" spinnerName="guestEventsLoader"></myp-inline-loader>
            }
            @for (event of newEvents; track event.id) {
              <myp-list-item
                [title]="event.title"
                [subData]="[event._formattedDate]"
                [showImage]="!!event.image_url"
                [photo]="event.image_url"
                [imageRound]="false"
                [largeImage]="true"
                marginBottom="10px"
                [description]="event.description"
                (itemClicked)="goToEvent(event)"
              ></myp-list-item>
            }
          </section>
        }

        <section class="home-section w-full m-b-50" aria-label="latest videos">
          <div class="section-header is-grid m-b-20">
            <fui-heading [text]="'sphere.latest_videos' | translate" [level]="2" fontSize="f8"></fui-heading>
            <a class="section-header-link" [routerLink]="['/learn/videos/all']">{{ "sphere.view_all" | translate }}</a>
          </div>
          @if (videosLoading) {
            <div class="grid-container even-rows pad-10">
              <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
              <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
              <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
              <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
            </div>
          }
          <ul class="list-inline grid-container wider even-rows pad-10">
            @for (video of videos; track video) {
              <li class="list-inline-item">
                <myp-video-grid-item [video]="video"></myp-video-grid-item>
              </li>
            }
          </ul>
        </section>

        <section class="home-section w-full m-b-50" aria-label="upgrades">
          <div class="section-header is-grid m-b-20">
            <fui-heading [text]="'home.upgrades_special_offers' | translate" [level]="2" fontSize="f8"></fui-heading>
          </div>
          <div class="align-items-center m-b-50 offer-container">
            <img
              [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxAnnual"
              class="m-r-20 offer-image"
              style="max-width: 300px; display: inline-block"
              width="100%"
              alt=""
            />
            <div class="offer-text">
              <fui-heading [text]="'home.subscribe_fender_studio_pro_plus' | translate" level="2" fontSize="f6"></fui-heading>
              {{ "home.fender_studio_pro_description" | translate }}
              <br />
              <br />
              <a type="button" class="btn btn-primary" [routerLink]="['/onboarding']">{{ "onboarding.join_now" | translate }}</a>
            </div>
          </div>
          <div class="align-items-center m-b-50 m-t-30 offer-container">
            <img
              src="https://www.fender.com/cdn-cgi/image/format=auto/https://images.ctfassets.net/mdpgzc1lmx9t/6dm00mq0ASKUzDJDdqaxEV/042e46e027dc46b6270eeebc6e325536/Fender_Studio_Edit_Tracks-v3.webp"
              class="m-r-20 offer-image"
              style="max-width: 300px; display: inline-block"
              width="100%"
              alt=""
            />
            <div class="offer-text">
              <fui-heading [text]="'home.fender_studio_mobile_app_free' | translate" level="2" fontSize="f6"></fui-heading>
              {{ "home.fender_studio_pro_description" | translate }}
              <br />
              <br />
              <img
                src="https://images.ctfassets.net/r1mvpfown1y6/I6wP6wbRgu6nl2WbKiTUr/0ebfd271a4fba0070940955c767f23a0/Download_on_the_App_Store_Badge.svg"
                style="width: 150px; margin-right: 10px; display: inline-block"
                alt=""
              />
              <img
                src="https://images.ctfassets.net/r1mvpfown1y6/cGKmfaCPBarxVgSTlprue/40bcb9596a2801c09c62d19d1a915c04/google-play-badge__2_.png"
                style="width: 150px; display: inline-block"
                alt=""
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>

<footer>
  <div class="secondary-content-bg">
    <div class="fullwidth-layout-container">
      <div class="p-t-50">
        <div class="container">
          <div class="row row-cols-1 row-cols-md-3 row-cols-xl-5">
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/fender-studio.png" alt="Fender Studio App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_studio_tagline" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.fender_studio_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/fender-studio-app" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/play-app-icon.png" alt="Fender Play App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_play" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "education.fender_play_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/play" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/tune-app-icon.png" alt="Fender Tune App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_tune" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.tune_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/online-guitar-tuner/" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/tone-app-icon.png" alt="Fender Tone App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_tone" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.tone_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/tone-app-amp-control" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/notion-app-icon.png" alt="Fender Notion App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_notion" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.notion_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/fender-notion" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
          </div>
        </div>
        <div class="m-t-100 p-b-50">
          <fui-footer></fui-footer>
        </div>
      </div>
    </div>
  </div>
</footer>
